import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getBudgets = (page = null, limit = null, search = '', sort = 'date', order = 'desc') => async (dispatch) => {
    dispatch({
        type: 'BUDGET_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/budget/getall', { page, limit, search, sort, order }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'BUDGET_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BUDGET_NOT_LOADING'
        })
    }
}

export const getBudget = (budget) => async (dispatch) => {
    dispatch({
        type: 'BUDGET_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/budget/get/' + budget, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'BUDGET_GET_SUCCESS',
                payload: data.budget
            })
        }
    } catch (error) {
        dispatch({
            type: 'BUDGET_NOT_LOADING'
        })
    }
}

export const addBudget = (budgetdata) => async (dispatch) => {
    dispatch({
        type: 'BUDGET_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/budget/register', budgetdata, {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'BUDGET_ADD_SUCCESS',
                payload: data
            })
        }
        if (status === 265) {
            dispatch({
                type: 'BUDGET_DUPLICATED',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BUDGET_NOT_LOADING'
        })
    }
}

export const editBudget = (budgetdata, idBudget) => async (dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/budget/edit/' + idBudget, budgetdata, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'BUDGET_EDIT_SUCCESS',
                payload: data
            })
        }
        if (status === 265) {
            dispatch({
                type: 'BUDGET_DUPLICATED',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BUDGET_ERROR'
        })
    }
}

export const removeBudget = (budgetId) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/budget/remove/' + budgetId, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        })
        if (status === 200 || status === 263) {
            dispatch({
                type: 'BUDGET_REMOVE_RESULT',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BUDGET_NOT_LOADING'
        })
    }
}

export const getNextBudgetNumber = () => async (dispatch) => {
    try {
        const { data, status } = await Axios.get('/api/budget/getnextbudgetnumber', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'BUDGET_GET_NEXT_NUMBER_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'BUDGET_NOT_LOADING'
        })
    }
}

export const updateAllAmpliations = (ampliations, idBudget) => async dispatch => {
    try {
        const { data, status } = await Axios.put(
            `/api/budget/updateallampliations/${idBudget}`, { ampliations },
            { headers: { auth: localStorage.getItem("jwt") } }
        );

        if (status === 200) {
            dispatch({
                type: "BUDGET_UPDATE_ALL_AMPLIATIONS_SUCCESS",
                payload: data
            });
        }

    } catch (error) {
        dispatch({ type: "BUDGET_NOT_LOADING" });
    }
};

export const duplicateBudget = (idBudget) => async dispatch => {
    try {
        const { data, status } = await Axios.post(
            `/api/budget/duplicate/${idBudget}`, {},
            { headers: { auth: localStorage.getItem("jwt") } }
        );
        if (status === 200) {
            dispatch({
                type: "BUDGET_DUPLICATE_SUCCESS",
                payload: data
            });
        }
    } catch (error) {
        dispatch({ type: "BUDGET_NOT_LOADING" });
    }
};

export const convertToWO = (idBudget, firstIndex, secondIndex) => async dispatch => {
    try {
        const { data, status } = await Axios.post(
            `/api/budget/converttowo`, { idBudget, firstIndex, secondIndex },
            { headers: { auth: localStorage.getItem("jwt") } }
        );
        if (status === 200) {
            dispatch({
                type: "BUDGET_CONVERT_TO_WO_SUCCESS",
                payload: data
            });
        }
    } catch (error) {
        dispatch({ type: "BUDGET_NOT_LOADING" });
    }
};